import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Checkbox } from '../../../../../Checkbox'
import { ConfirmationModal } from '../../../../../Confirmation'
import Text from '../../../../../Text'
import {
  APPLICANT_CREDIT_CHECK_ACTION_LABEL_KEY,
  APPLICANT_CREDIT_CHECK_GATE_TITLE_KEY,
  QA_NAME_APPLICANT_CREDIT_CHECK_GATE,
  QA_NAME_APPLICANT_CREDIT_CHECK_GATE_ACKNOWLEDGE,
} from '../ApplicantCreditCheckBlock.constants'
import {
  getApplicantCreditCheckConsentText,
  getApplicantCreditCheckConsentVersionText,
  getApplicantCreditCheckGateNotifications,
} from '../ApplicantCreditCheckBlock.utils'

import * as styles from './ApplicantCreditCheckGateModal.module.css'

function ApplicantCreditCheckGateModal({
  creditCheck,
  mode,
  onClose,
  onSubmit,
}) {
  const { t } = useTranslation()

  const [isAcknowledged, setAcknowledged] = useState(false)

  const [hasError, setError] = useState(false)

  const consentVersionText = getApplicantCreditCheckConsentVersionText({
    creditCheck,
    t,
  })

  async function handleSubmit() {
    setError(false)

    try {
      await onSubmit()
    } catch {
      setError(true)
    }
  }

  const notifications = getApplicantCreditCheckGateNotifications({
    hasError,
    t,
  })

  return (
    <ConfirmationModal
      actionButtonsProps={{
        submitProps: {
          disabled: !isAcknowledged,
          tooltip: isAcknowledged
            ? null
            : t('RentalPortal.ApplicantCreditCheckGateAcknowledgeTooltipKey'),
        },
        submitText: t(APPLICANT_CREDIT_CHECK_ACTION_LABEL_KEY[mode]),
      }}
      description={t('RentalPortal.ApplicantCreditCheckGateBodyKey')}
      notifications={notifications}
      qaName={QA_NAME_APPLICANT_CREDIT_CHECK_GATE}
      title={t(APPLICANT_CREDIT_CHECK_GATE_TITLE_KEY[mode])}
      onCancel={onClose}
      onSubmit={handleSubmit}
    >
      <div className={styles.gateBody}>
        <div className={styles.gateConsent}>
          <Text className={styles.line}>
            {getApplicantCreditCheckConsentText({ creditCheck, t })}
          </Text>
          {consentVersionText ? (
            <Text isSecondary className={styles.line}>
              {consentVersionText}
            </Text>
          ) : null}
          <Text isSecondary className={styles.line}>
            {t('RentalPortal.ApplicantCreditCheckConsentBasisKey')}
          </Text>
        </div>

        <Checkbox
          checked={isAcknowledged}
          className={styles.gateAcknowledge}
          label={t('RentalPortal.ApplicantCreditCheckGateAcknowledgeKey')}
          qaName={QA_NAME_APPLICANT_CREDIT_CHECK_GATE_ACKNOWLEDGE}
          onChange={setAcknowledged}
        />
      </div>
    </ConfirmationModal>
  )
}

export default ApplicantCreditCheckGateModal
